import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Estagio from "model/producao/Estagio";
import Transacao from "model/suprimentos/Transacao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class EstagioService implements BaseServiceCadastros<Estagio> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/estagio/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Estagio>((resolve, reject): void => {
            api
                .get(`/estagio/consultar/${id}`)
                .then(response => {
                    const estagio: Estagio = response.data;
                    estagio.estagioUsuarios.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(estagio);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(estagio: Estagio) {
        return new Promise<Estagio>((resolve, reject): void => {
            api
                .post(`/estagio/incluir`, JSON.stringify(estagio))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(estagio: Estagio) {
        return new Promise<Estagio>((resolve, reject): void => {
            api
                .put(`/estagio/editar`, JSON.stringify(estagio))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/estagio/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/estagio/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    transacoes() {
        return new Promise<Transacao[]>((resolve, reject): void => {
            api
                .get(`/estagio/transacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/estagio/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default EstagioService;